<template>
  <div class="main-popup">
    <div v-if="loadingPage" class="load-parent">
      <div class="loader"></div>
    </div>

    <div class="pop-up" :style=" isComponent ? {boxShadow:'none' , padding:'0' } : {}">
      <div v-if="!isComponent" class="head">
        <h4>درخواست جدید</h4>

      </div>


      <div class="accordion-div" v-if="acc.length > 0">
        <div v-for="(accitem,index) in acc" :key="accitem.id" class="accordion">
          <div @click="accitem.active = !accitem.active" class="head" :class="{'pb-3':!accitem.active}">
            <span>{{ accitem.title }}</span>
            <div v-if="!this.isComponent" class="d-flex btns-top">
              <button v-if="acc.length > 1" type="button" @click="removeAcc(index)">
                <i class="fa-regular fa-trash"></i>
                حذف
              </button>
              <i class="fa-regular fa-angle-down" :class="{'fa-angle-up':accitem.active}"></i>
            </div>
          </div>

          <div class="form-par" :class="{'active':accitem.active}">

            <form>
              <div class="form mt-5 w-100">
                <div v-if="isVoiceMail" class="sound mr-auto d-flex align-items-center">
                  <v-btn variant="text" class="btn d-flex align-items-center me-2" @click="downloadFile()"><i
                      class="fa fa-download me-2"></i></v-btn>

                  <audio id="audio" controls>
                    <source :src="apiUrl + 'api/voicemails/download/'+dataProp.portalInfo.id" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>

                </div>
                <div class="title d-flex w-100">

                  <h5 class="w-auto">مشخصات مُراجع</h5>
                  <button v-if="!isComponent" @click="contactShow = true ; indexTaskSelected = index"
                          :disabled="disableContact[index].val"
                          type="button" class="btn btn-users"><i
                      class="fa-regular fa-user ml-2"></i>استفاده از مخاطب همخوان
                  </button>
                  <button v-if="!isComponent" @click="contactAllShow = true ; indexTaskSelected = index"
                          type="button" class="btn btn-users mr-2"><i
                      class="fa-regular fa-user ml-2"></i>همه مخاطبین
                  </button>
                  <button v-if="isComponent2" @click="getLastTasksFunc(index)"
                          type="button" class="btn btn-users mr-2"><i
                      class="fa-regular fa-list-check ml-2"></i>انتخاب از تسک های قبلی
                  </button>
                </div>
                <div class="input">
                  <label>کد رهگیری</label>
                  <input disabled v-model="forms[index].code" type="text"/>
                </div>
                <div class="input">
                  <label>نام </label>
                  <input v-max-length="250" type="text" placeholder="مثال: علی " v-model="forms[index].name"/>
                </div>
                <div class="input">
                  <label>نام خانوادگی </label>
                  <input v-max-length="250" type="text" placeholder="مثال: احمدی"
                         v-model="forms[index].family"/>
                </div>
                <div class="input">
                  <label>کد ملی</label>
                  <input v-max-length="10" @input="onlyNumber(index)" type="text" placeholder="مثال:  0012345679"
                         v-model="forms[index].meli_code"/>
                </div>
                <div class="input">
                  <label>شماره ثابت</label>
                  <input v-max-length="12" @input="onlyNumber(index)" type="text" placeholder="مثال:  02122334455"
                         v-model="forms[index].tel"/>
                </div>
                <div class="input">
                  <label>شماره موبایل</label>
                  <input @input="onlyNumber(index)"
                         v-max-length="12"
                         @focusout="findContact(forms[index].phone ,index)"
                         type="text" placeholder="مثال: 09121234567"
                         v-model="forms[index].phone"/>
                </div>

                <div class="input">
                  <label>استان مبدا تماس</label>
                  <v-autocomplete
                      class="tags-autocomplete"
                      label=""
                      v-model="forms[index].province"
                      :items="provinces"
                      item-title="name"
                      item-value="id"
                      variant="underlined"
                      @update:modelValue="getTasksLocation(index)"
                  ></v-autocomplete>
                </div>
                <div class="input">
                  <label>شهر </label>
                  <v-autocomplete
                      class="tags-autocomplete"
                      label=""
                      :disabled="disableCity[index].val"
                      v-model="forms[index].city"
                      :items="cities[index]"
                      item-title="name"
                      item-value="name"
                      variant="underlined"
                      :loading="loading"
                  ></v-autocomplete>
                </div>

              </div>
              <div ref="addButton" class="btns-add">
                <div class="tree-box" v-show="showTree">
                  <TreeView2 :nodes="treeData" :initialSelected="accitem?.id"
                             @update-single="(node) => handleSelection2(node, index)"/>
                </div>
                <button type="button" @click="showTree = !showTree"><i class="fa-regular fa-folder-plus"></i>
                  {{ accitem.titleButton }}
                </button>
              </div>
              <div class="forms-custom w-100 form" v-for="(item,indexParent) in accitem.forms" :key="item.id">
                <h5>{{ item.title }}</h5>
                <p class="w-100">{{ item.description }}</p>
                <div v-for="field in item.fields" :key="field.id" class="input field-box">
                  <label>{{ field.title }} <em v-if="field.required ===	1">*</em></label>


                  <div class="check-div" v-if="field.field_type ==='checkbox'">

                    <div v-for="(check,i) in field.options" :key="i">
                      <input :id="'check-'+i"
                             :name="field.field_type"
                             :value="check.value"
                             v-model="checkboxesModel"

                             type="checkbox">
                      <label :for="'check-'+i">{{ check.value }}</label>
                    </div>
                  </div>

                  <div class="radio-div" v-if="field.field_type	 ==='radio'">

                    <div v-for="(radio,index) in field.options" :key="radio.value">
                      <input :id="'radio-'+index" :value="radio.value" type="radio"
                             v-model="formDataArr[item.id][field.id]"

                             :name="'radio-'+indexParent">
                      <label :for="'radio-'+index">{{ radio.value }}</label>
                    </div>
                  </div>
                  <div class="select-div"

                       v-if="field.field_type ==='single_select' || field.field_type ==='multiple_select'">

                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        v-model="formDataArr[item.id][field.id]"
                        :items="field.options"
                        item-title="value"

                        variant="underlined"
                        :multiple="field.field_type === 'multiple_select'"
                    ></v-autocomplete>

                  </div>

                  <input v-max-length="250" v-if="field.field_type === 'text' || field.field_type === 'number'"

                         v-model="formDataArr[item.id][field.id]"
                         :placeholder="field.placeholder" :type="field.field_type ==='text' ? 'text' :'number'"/>
                  <!--                  <input v-if="field.field_type === 'date'"
                                           v-model="formDataArr[item.id][field.id]"

                                           :placeholder="field.placeholder" type="text"/>-->
                  <date-picker v-if="field.field_type === 'date'"
                               class="input-date"
                               placeholder=" تاریخ"
                               @selected="getDate(item.id,field.id,$event)"
                               v-model="formDataArr[item.id][field.id]"
                               :value="formDataArr[item.id][field.id]"/>
                  <textarea v-if="field.field_type === 'textarea'"

                            v-model="formDataArr[item.id][field.id]"
                            :placeholder="field.placeholder"></textarea>


                </div>

              </div>


              <div class="form mt-5 w-100">

                <div class="input w-100">
                  <label>تگ ها</label>
                  <v-autocomplete
                      class="tags-autocomplete"
                      label=""
                      v-model="forms[index].tags"
                      :items="tags"
                      item-title="title"
                      item-value="id"
                      multiple
                      variant="underlined"
                  ></v-autocomplete>
                </div>
                <div class="input">
                  <label>میزان اهمیت</label>
                  <v-autocomplete
                      class="tags-autocomplete"
                      label=""
                      v-model="forms[index].level"
                      :items="levels"
                      item-title="name"
                      item-value="index"
                      variant="underlined"
                  ></v-autocomplete>
                </div>
                <div class="input">
                  <label>باز/بسته</label>
                  <v-autocomplete
                      class="tags-autocomplete"
                      label=""
                      v-model="forms[index].is_closed"
                      :items="['باز','بسته']"

                      item-title="name"
                      item-value="index"
                      variant="underlined"
                  ></v-autocomplete>
                </div>
                <div class="input">
                  <label>وضعیت</label>
                  <v-autocomplete
                      class="tags-autocomplete"
                      label=""
                      v-model="forms[index].status_id"
                      :items="statuses"
                      item-title="title"
                      item-value="id"
                      variant="underlined"
                  ></v-autocomplete>
                </div>
              </div>


              <div class="attachments">

                <div class="right-box mb-4">
                  <h6 class="mb-2">فایل ضمیمه</h6>
                  <div v-for="(file,f) in attachment[index]" :key="f" class="attach">
                    <i class="fa-regular fa-paperclip"></i>
                    <span v-if="!isComponent">{{ file?.name || file?.file_name }}</span>
                    <span v-if="isComponent">{{ file?.file_path || file?.file_name || file?.name }}</span>
                    <button v-if="!isComponent" @click="removeAttach(index,f)" type="button"
                            class="fa-regular fa-trash"></button>
                    <v-btn :loading="file.loading" v-if="isComponent" @click="downloadAttach(file)"
                           class="btn btn-download">
                      دانلود <i class="fa-regular fa-cloud-download"></i></v-btn>
                  </div>


                  <!--                  <button class="btn-upload">
                                      <input type="file" accept="image/*,application/pdf"
                                             multiple

                                             @change="handleFileUpload(index)">
                                      <i class="fa-regular fa-"></i> آپلود فایل
                                    </button>-->

                  <v-btn
                      variant="text"
                      class="btn-upload w-100 h-auto"
                      @click="attachInfoModal = true"
                  >
                    <i class="fa-light fa-paperclip"></i>
                    <span>آپلود فایل</span>
                  </v-btn>

                  <v-dialog v-model="attachInfoModal" max-width="550">
                    <v-card class="excel-upload-modal">
                      <v-card-text class="pa-8 text-center">

                        <div class="excel-icon">
                          <i class="fa-light fa-paperclip"></i>
                        </div>

                        <h2 class="mt-4 mb-2">آپلود فایل ضمیمه</h2>

                        <p class="text-grey-darken-1 mb-6">
                          لطفاً قبل از انتخاب فایل، محدودیت‌های زیر را مطالعه کنید.
                        </p>

                        <div class="upload-rules">
                          <div class="rule-item">
                            <i class="fa-light fa-file-check"></i>
                            <span>فرمت‌های مجاز: Image ، Pdf  </span>
                          </div>

                          <div class="rule-item">
                            <i class="fa-light fa-hard-drive"></i>
                            <span>حداکثر حجم فایل: 1 مگابایت</span>
                          </div>

                        </div>
                        <div class="validation-list my-6">
                          <div v-for="(item, i) in validationFiles" :key="i"
                               class="file-item d-flex align-center pa-3 mb-3 rounded-lg"
                               :class="{ 'valid-file': item.isValid, 'invalid-file': !item.isValid }">

                            <!-- Preview -->
                            <div v-if="item.preview" class="mr-4 flex-shrink-0">
                              <img :src="item.preview"
                                   style="width: 52px; height: 52px; object-fit: cover; border-radius: 6px;">
                            </div>
                            <div v-else class="mr-4 flex-shrink-0">
                              <i class="fa-light fa-file" style="font-size: 42px; color: #666;"></i>
                            </div>

                            <!-- اطلاعات فایل -->
                            <div class="flex-grow-1">
                              <div class="font-weight-medium ">{{ item.name }}</div>
                              <div class="text-grey-darken-1">{{ item.size }}</div>

                              <div v-if="item.errors.length" class="mt-1 red--text font-weight-medium">
                                {{ item.errors.join("، ") }}
                              </div>
                            </div>


                            <v-btn
                                v-if="!item.isValid"
                                icon
                                color="red"
                                @click="removeValidationFile(i)"
                            >
                              <i class="fa fa-close"></i>
                            </v-btn>
                          </div>
                        </div>

                      </v-card-text>

                      <v-divider/>

                      <v-card-actions class="pa-4">
                        <v-spacer/>

                        <v-btn
                            variant="text"
                            color="grey"
                            @click="attachInfoModal = false"
                        >
                          انصراف
                        </v-btn>

                        <v-btn
                            @click="selectAttach(index)"
                            class="add-btn-attach"
                        >
                          انتخاب فایل
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <input
                      ref="attachInputs"
                      type="file"
                      multiple
                      style="display:none"
                      accept="image/*,application/pdf"
                      @change="handleFileUpload(index, $event)"
                  />

                </div>

                <div class="left-box w-100 p-0">
                  <div class="label mb-2 d-flex align-items-center">
                    <h6 class="mb-0 ml-auto"> توضیحات</h6>
                    <v-btn v-if="!isComponent && aiAccess" style="box-shadow: none;"
                           :loading="loadingAiModule"
                           type="button"
                           @click="getAiModule(index)" class=" btn btn-ai-response">استعلام از دیگر سامانه ها
                    </v-btn>
                    <v-btn v-if="!isComponent && aiAccess" style="box-shadow: none;"
                           :loading="loadingAi" type="button"
                           @click="getAi(index)"
                           class="mr-2 btn btn-ai-response">پاسخ هوش مصنوعی
                    </v-btn>

                  </div>
                  <textarea v-max-length="500" v-model="forms[index].description"></textarea>
                </div>
                <div class="left-box w-50 pt-2">
                  <h6 class="mb-2 d-flex align-items-center">
                    <span>پاسخ</span>
                    <button v-if="isVoiceMail" type="button" @click="recordeVoiceFunc(index)"
                            class="mr-auto btn btn-ai-response">ضبط پاسخ صوتی
                    </button>
                  </h6>
                  <textarea v-max-length="500" v-model="forms[index].answer"></textarea>
                </div>
                <div class="left-box w-50 pt-2">
                  <h6 class="mb-2"> یادداشت</h6>
                  <textarea v-max-length="500" v-model="forms[index].note"></textarea>
                </div>

                <div class="row mx-0 mt-3 w-100">
                  <div class="col-md-6">
                    <div class="comments">

                      <div v-for="item in notes" :key="item?.id" class="box-c">
                        <p v-html="item?.note"></p>
                        <div class="bottom">
                          <span> <i class="fa-regular fa-calendar"></i> {{ toJalali(item?.created_at) }}</span>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="comments">

                      <div v-for="item in answers" :key="item?.id" class="box-c">
                        <p v-html="item?.answer	"></p>
                        <div class="bottom">
                          <span> <i class="fa-regular fa-calendar"></i> {{ toJalali(item?.created_at) }}</span>
                        </div>
                      </div>


                    </div>
                  </div>


                </div>
              </div>


              <div class="btns-bottom">

                <v-btn :disabled="taskAddedSuccessful[index] || loading" @click="ShowTransmissionModal(index)"
                       class="btn-transmission mt-4 mb-5"><i
                    class="fa-light fa-users"></i>ذخیره وانتقال
                </v-btn>
                <v-btn :disabled="taskAddedSuccessful[index]" :loading="loading"
                       @click="submitRequest(index)" class="btn-save mt-1 mb-5">
                  <i class="fa-light fa-floppy-disk"></i>
                  {{ taskAddedSuccessful[index] ? 'با موفقیت ثبت شد' : 'ذخیره' }}
                </v-btn>
              </div>


            </form>
          </div>

        </div>
      </div>

      <div v-if="!isComponent && !isComponent2" class="col-12 px-2">
        <div @click="addNewAcc" class="add-new-button">
          <span><i class="fa-regular fa-plus"></i>افزودن </span>
        </div>
      </div>

      <div v-if="Object.keys(errors).length > 0" class="alert w-100 alert-danger mt-3 mb-0" role="alert">
        <div v-for="(err,index) in errors" :key="index">
          <span v-for="(msg,i) in err" :key="i">{{ index }} : {{ msg }}</span>
        </div>
      </div>

    </div>

    <v-dialog
        class="remove-dialog"
        v-model="confirmChangeContact"
        max-width="600"
        persistent
    >

      <v-card
          text=""
          title=""
      >
        <template v-slot:actions>

          <div>
            <button></button>
            <span class="text-right p-0 px-4 d-block">در اطلاعات مخاطب تغییری داده شده است، میخواهید به عنوان مخاطب جدید درج شود؟ یا
              مخاطب فعلی ویرایش شود ؟</span>
            <v-spacer></v-spacer>
            <div class="btns mt-4">
              <v-btn class="px-2" @click="editContact = 1;submitRequest(indexTaskSelected,false)">
                مخاطب فعلی ویرایش شود
              </v-btn>

              <v-btn class="px-2" :loading="loading" @click=" editContact = 2;submitRequest(indexTaskSelected,false)">
                درج به عنوان مخاطب جدید
              </v-btn>
            </div>
          </div>

        </template>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="transmissionModal"
        class="dialog-transmission"
        width="740px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>انتقال درخواست</h5>
          <i @click="transmissionModal = false" class="fa-regular fa-close"></i>
        </div>

        <div class="forms">

          <div class="input">
            <label>انتخاب دپارتمان</label>
            <v-autocomplete
                class="tags-autocomplete"
                label=""
                item-title="title"
                item-value="id"
                v-model="departmentsModel[indexTaskSelected].id"
                :items="deparments.data"
                variant="underlined"
            ></v-autocomplete>
          </div>
          <div class="input">
            <label>انتخاب کارشناس</label>
            <v-autocomplete
                class="tags-autocomplete"
                label=""
                item-title="name"
                item-value="id"
                v-model="departmentsModel[indexTaskSelected].user"
                :items="departmentUsers"
                variant="underlined"
                :disabled="this.userInfo.department_id !== departmentsModel[indexTaskSelected].id"

            ></v-autocomplete>
          </div>

          <v-btn :loading="loading" @click="submitRequest(indexTaskSelected,true)" class="btn-save mt-4 mb-5"><i
              class="fa-light fa-users"></i>تکمیل انتقال
          </v-btn>

        </div>
      </div>
    </v-dialog>
    <v-dialog
        v-model="contactShow"
        class="dialog-contact"
        width="740px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>لیست مخاطبین</h5>
          <i @click="contactShow = false" class="fa-regular fa-close"></i>
        </div>
        <div class="input w-100">
          <label class="mt-2 mb-1">مخاطبین</label>
          <v-autocomplete
              class="tags-autocomplete"
              label=""
              v-model="forms[indexTaskSelected].contactId"
              :items="contacts[indexTaskSelected]"
              item-title="name"
              item-value="id"
              variant="underlined"
              :loading="loadingContact"
          ></v-autocomplete>
        </div>
        <btn class="btn btn-save" @click="setContactInfo(forms[indexTaskSelected].contactId , indexTaskSelected)">
          ذخیره
        </btn>


      </div>
    </v-dialog>
    <v-dialog
        v-model="contactAllShow"
        class="dialog-contact"
        width="740px"
    >
      <div class="box-modal contact-all-list">
        <div class="top mb-2">
          <h5>لیست همه مخاطبین</h5>
          <i @click="contactAllShow = false" class="fa-regular fa-close"></i>
        </div>
        <div class="head-table">
          <div class="right">
            <v-btn @click="filterShow = !filterShow" :class="{'active':filterShow}" variant="text" class="btn-filter">
              <i class="fa-light fa-filter"></i>
              <span class="text">فیلتر</span>
            </v-btn>
          </div>
        </div>
        <div v-if="filterShow" class="filter-row">
          <div class="input">
            <input type="text" placeholder="نام " v-model="filterVals.name"
                   @input="debouncedSearch('نام' ,'name')"
            >
          </div>
          <div class="input">
            <input type="text" placeholder="نام خانوادگی" v-model="filterVals.family"
                   @input="debouncedSearch('نام خانوادگی' ,'family')"
            >
          </div>
          <div class="input">
            <input type="text" placeholder="شماره همراه" v-model="filterVals.phone"
                   @input="debouncedSearch('شماره همراه' ,'phone')"
            >
          </div>


        </div>
        <div v-if="filterShow" class="tags">
          <div class="tag" v-for="(tag, index) in tagsFilter" :key="index">
            <em>{{ tag.title }}</em>:{{ tag.valueTitle }}
            <i class="fa-regular fa-close" @click="removeTag(index ,tag.name)"></i>
          </div>
        </div>

        <div class="table-section">
          <div v-if="loadingPage" class="load-parent">
            <div class="loader"></div>
          </div>
          <table v-if="contactsAll?.data?.length > 0" class="table table-striped">
            <thead>
            <tr>
              <th scope="col"> شناسه</th>
              <td>نام و نام خانوادگی</td>
              <td>تلفن</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in contactsAll.data" :key="item.id">
              <th>{{ item.id }}</th>
              <td>{{ item.name }} {{ item.family }}</td>
              <td>{{ item.phones.mobile }}</td>
              <td>
                <button @click="setContactInfo2(item)" class="add-contact">افزودن</button>
              </td>
            </tr>


            </tbody>
          </table>
          <h1 v-else class="no-find">هیچ موردی یافت نشد!</h1>
        </div>

      </div>
    </v-dialog>
    <v-dialog
        v-model="tasksAllShow"
        class="dialog-contact"
        width="740px"
    >
      <div class="box-modal contact-all-list">
        <div class="top mb-2">
          <h5>لیست تسک ها</h5>
          <i @click="tasksAllShow = false" class="fa-regular fa-close"></i>
        </div>

        <div class="filter-row">
          <div class="input w-50 position-relative">

            <v-text-field label="" v-model="taskIdSearch" :disabled="loadingSearch" :loading="loadingSearch"
                          placeholder="جستجوی شناسه ... " variant="underlined"></v-text-field>
          </div>


        </div>


        <div class="table-section">
          <div v-if="loadingPage" class="load-parent">
            <div class="loader"></div>
          </div>
          <table v-if="lastTasks?.length > 0" class="table table-striped">
            <thead>
            <tr>
              <th scope="col"> شناسه</th>
              <td>استان</td>
              <td>شهر</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in lastTasks" :key="item.id">
              <th>{{ item.id }}</th>
              <td>{{ item.province }} {{ item.family }}</td>
              <td>{{ item.city }}</td>
              <td>
                <v-btn :loading="item.taskEditLoading" @click="getTaskInfo(item)" class="add-contact">انتخاب</v-btn>
              </td>
            </tr>


            </tbody>
          </table>
          <h1 v-else class="no-find">هیچ موردی یافت نشد!</h1>
        </div>

      </div>
    </v-dialog>
    <v-dialog
        v-model="aiShow"
        class="dialog-ai"
        width="740px"
    >
      <div class="box-modal">
        <h5 class="w-100 text-right mb-3">{{ aiResponse?.input_text }}</h5>
        <div style="white-space: pre" v-if="aiResponse?.suggestion !== null && aiResponse?.suggestion !== ''"
             v-html="aiResponse?.suggestion"
        >
        </div>
        <p v-else>{{ this.aiResponse?.message }}</p>
        <div class="d-flex align-items-center justify-content-end w-100 mt-4">
          <v-btn class="btn btn-cancel" @click="aiShow = false">
            انصراف
          </v-btn>
          <v-btn v-if="aiResponse?.suggestion !== null && aiResponse?.suggestion !== ''"
                 @click="userAiResponse()" class="btn btn-save w-auto mr-2 mt-0">
            استفاده از پاسخ
          </v-btn>

        </div>


      </div>
    </v-dialog>
    <v-dialog
        v-model="aiModuleShow"
        class="dialog-ai"
        width="740px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>لیست دیگر سامانه ها</h5>
          <i @click="aiModuleShow = false" class="fa-regular fa-close"></i>
        </div>
        <div class="list-text-data">
          <span v-for="item in aiModuleResponse" :key="item.id">{{ item.text_data }}</span>

        </div>


        <div class="d-flex align-items-center justify-content-end w-100">
          <v-btn class="btn btn-cancel" @click="aiModuleShow = false">
            بستن
          </v-btn>


        </div>


      </div>
    </v-dialog>
    <v-dialog
        v-model="voiceRecorderModal"
        class="dialog-ai"
        width="500px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>ضبط صدا</h5>
          <i @click="voiceRecorderModal = false" class="fa-regular fa-close"></i>
        </div>

        <div class="w-100 my-3">
          <AudioRecorder :file="this.forms[this.indexTaskSelected].answer_attachments" @audioSelected="submitAudio"/>
        </div>


      </div>
    </v-dialog>
    <v-snackbar
        :timeout="3000"
        v-model="snackbar"
        :color="colorSnack"
    >
      {{ textSnack }}

      <template v-slot:actions>
        <v-btn

            variant="tonal"
            @click="snackbar = false"
        >
          <i class="fa-regular fa-close"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "@/plugins/axios.js";
import store from "@/store";
import datePicker from "@/components/Calendar";
import moment from "moment-jalaali";
import {defineAsyncComponent} from "vue";
import AudioRecorder from "@/components/AudioRecorder";
import {useUserStore} from "@/store/user";

export default {
  name: "NewRequestView",
  components: {
    AudioRecorder, TreeView2: defineAsyncComponent(() =>
        import('@/components/TreeView2.vue')
    ), datePicker
  },
  props: {
    isComponent: {
      type: Boolean,
      default: false,
      required: false
    },
    isVoiceMail: {
      type: Boolean,
      default: false,
      required: false
    },
    isComponent2: {
      type: Boolean,
      default: false,
      required: false
    },
    dataProp: {
      type: Object,
      required: false

    },
    typeId: {
      type: Number,
      default: 0,
      required: false
    },
    typeTitle: {
      type: String,
      default: '',
      required: false
    },
    eventData: {
      type: Object,
      default: () => ({}),
      required: false
    },


  },
  data() {
    return {
      apiUrl: store.getters.baseUrl,
      apiBaseUrl: window.appConfig.API_URL_BASE,
      selectedRate: 1,
      showTree: false,
      confirmChangeContact: false,
      snackbar: false,
      contactShow: false,
      contactAllShow: false,
      tasksAllShow: false,
      filterShow: false,
      loadingSearch: false,
      voiceRecorderModal: false,
      textSnack: '',
      filterName: '',
      colorSnack: '',
      taskIdSearch: '',
      loading: false,
      loadingAi: false,
      loadingAiModule: false,
      editContact: 0,
      aiModuleShow: false,
      errors: {},
      loadingContact: false,
      selectedNode: null,
      loadingPage: false,
      attachInfoModal: false,
      perPage: 20,
      treeData: [],
      contactsAll: [],
      checkboxesModel: [],
      lastTasks: [],
      answers: [],
      notes: [],
      tags: "",
      tagsFilter: [],
      timeout: null,
      transmissionModal: false,
      cartable_id: 0,
      aiShow: false,
      aiResponse: '',
      aiModuleResponse: [],
      acc: [],
      provinces: [],
      contacts: [],
      cities: [],
      filterVals: {
        name: '',
        family: '',
        phone: '',
      },
      aiAccess: false,
      disableCity: Array.from({length: 20}, () => ({
        val: true
      })),
      disableContact: Array.from({length: 20}, () => ({
        val: true
      })),
      taskAddedSuccessful: Array.from({length: 20}, () => ({
        val: false
      })),

      deparments: [],
      departmentUsers: [],
      levels: [],
      nodeId: '',
      formDataArr: {},
      departmentsModel: Array.from({length: 20}, () => ({
        id: '',
        user: '',
      })),
      contactSelected: '',
      related: Array.from({length: 20}, () => false),
      forms: Array.from({length: 20}, () => ({
        code: '',
        type_id: '',
        name: '',
        family: '',
        meli_code: '',
        tel: '',
        phone: this.eventData.callerid,
        province: '',
        city: '',
        tags: '',
        contactId: '',
        description: '',
        level: 0,
        status_id: '',
        note: '',
        answer: '',
        fileds: '',
        is_closed: 'بسته',

      })),
      attachment: [],
      files: Array.from({length: 20}),
      fields: [],
      validationFiles: [],
      statuses: [],
      userInfo: {},
      indexTaskSelected: '',
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  },
  computed: {
    userData() {
      return useUserStore().getUserInfo
    }
  },
  watch: {
    taskIdSearch(val) {

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {

        this.getLastTasks(val)

      }, 1000);

    },
    isComponent2: {
      handler() {
        console.log('021')

      },
      deep: true
    },
    tagsFilter: {
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getContacts(true)

        }, 1000);

      },
      deep: true
    },
    updateMode(val) {
      if (!val) {
        this.reset()
      }
    },


  },
  methods: {
    selectAttach(index) {
      const input = this.$refs.attachInputs;

      if (Array.isArray(input)) {
        input[index].click();
      }
    },
    submitAudio(file) {
      console.log("فایل دریافت شد:", file);
      this.voiceRecorderModal = false
      this.forms[this.indexTaskSelected].answer_attachments = file
    },
    async downloadFile() {
      let urlBase = this.apiUrl + 'api/voicemails/download/' + this.dataProp.portalInfo.id
      axios.get(urlBase, {
        headers: this.headers,
        responseType: "blob",
      })
          .then((response) => {

            const url = window.URL.createObjectURL(response.data);
            const a = document.createElement("a");
            a.href = url;

            const disposition = response.headers["content-disposition"];
            let fileName = 'file';
            if (disposition && disposition.includes("filename=")) {
              fileName = disposition.split("filename=")[1].replace(/['"]/g, "");
            }

            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error("Error downloading file:", error)
          })
    },
    getLastTasksFunc(index) {
      this.tasksAllShow = true;
      this.indexTaskSelected = index;
      this.taskIdSearch = ''
    },
    handleClickOutside(event) {
      const buttons = this.$refs.addButton;
      if (buttons) {
        const isClickInsideAny = Array.from(buttons).some((el) =>
            el.contains(event.target)
        );
        if (!isClickInsideAny) {
          this.onOutsideClick();
        }
      }

    },
    getContacts(filter = false, page = 1) {
      this.loadingPage = true
      let url = this.apiBaseUrl + 'api/contact?per_page=' + this.perPage
      if (page !== 1) {
        url = `${this.apiBaseUrl}api/contact?page=${page}&per_page=${this.perPage}`
      }
      let filterUrl = ''
      if (filter) {
        this.tagsFilter.forEach(item => {
          filterUrl += `&${item.name}=${item.value}`
          url += filterUrl
        })

      }

      axios.get(url, {headers: this.headers})
          .then(res => {
            this.loadingPage = false
            if (res.data.status === 'success') {
              this.contactsAll = res.data.data

            } else {
              this.contactsAll = []
            }
          })
          .catch(err => {
            if (err?.response?.status === 401) {
              this.logout()
            }
          })
    },
    onOutsideClick() {
      this.showTree = false
    },
    addNewAcc() {
      this.acc.push({
        id: this.acc.length + 1,
        active: true,
        title: 'گروه درخواستی انتخاب نشده',
        titleButton: 'افزودن گروه درخواست',
        idNode: ''
      })
      this.setTaskType()
    },
    getDate(itemId, fieldId, date) {
      this.formDataArr[itemId][fieldId] = date
    },
    removeTag(index, name = '') {
      this.tagsFilter.splice(index, 1);
      this.filterVals[name] = ''
    },
    userAiResponse() {
      this.aiShow = false;
      let index = this.indexTaskSelected
      this.forms[index].answer = this.aiResponse.suggestion
    },
    ShowTransmissionModal(index) {
      this.transmissionModal = true
      this.userInfo = this.userData
      this.departmentsModel[index].id = this.userInfo.department_id
      this.departmentsModel[index].user = ''
      this.indexTaskSelected = index
    },
    removeAttach(index, f) {
      this.attachment[index].splice(f, 1)
      this.files[index].splice(f, 1)
    },
    downloadAttach(file) {
      file.loading = true

      axios.post(this.apiBaseUrl + 'api/oncestorage/create', {
        path: file.file_path
      }, {
        headers: this.headers
      })
          .then(res => {
            const url = this.apiBaseUrl + 'api/oncestorage/' + res.data.path

            const link = document.createElement('a')
            link.href = url
            link.download = file.file_name || 'downloaded-file'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            file.loading = false
          })
          .catch(err => {
            file.loading = false
            if (err?.response?.status === 401) {
              this.logout()
            } else {
              console.error('Download error:', err)
            }
          })
    },
    getAiModule(index) {

      if (this.forms[index].type_id === '') {
        this.showMsg('لطفا یک گروه درخواست انتخاب کنید!', 'red')
        return
      }
      const fieldMap = [
        {key: "name", label: "نام"},
        {key: "family", label: "نام خانوادگی"},
        {key: "meli_code", label: "کد ملی"},
        {key: "phone", label: "شماره موبایل"},
        {key: "tel", label: "شماره ثابت"},
        {key: "province", label: "استان مبدا تماس"},
        {key: "city", label: "موقعیت مراجع"},
        {key: "level", label: "میزان اهمیت"},
        {key: "status_id", label: "وضعیت"},
        {key: "answer", label: "پاسخ"},
        {key: "description", label: "توضیحات"},
        {key: "note", label: "یادداشت"},
        {key: "fileds", label: "فیلدها"},
        {key: "tags", label: "تگ ها"}
      ];
      let fields = []
      this.acc[index].forms.forEach(form => {
        form?.fields?.forEach(field => {

          let value = this.formDataArr[form.id][field.id]
          if (field.field_type === 'multiple_select') {
            value = value.join(',')
          } else if (field.field_type === 'checkbox') {
            value = this.checkboxesModel.join(',')
          }
          if (value !== '') {

            fields.push({key: field.title, value: value})
          }

        })
      })
      this.loadingAiModule = true
      let additional_data = fieldMap
          .filter(field => {
            const val = this.forms[index][field.key];
            return val !== undefined && val !== null && val !== "";
          })
          .map(field => ({
            key: field.label,
            value: this.forms[index][field.key]
          }));
      if (fields.length > 0) {
        additional_data = [...additional_data, ...fields];
      }

      let body = {
        task_type_id: +this.nodeId,
        additional_data: additional_data
      }
      axios.post(this.apiBaseUrl + 'api/ai-modules/by-task-type', body,
          {headers: this.headers}).then(res => {
        this.loadingAiModule = false
        if (res.data.data.length === 0) {
          this.showMsg('هیچ موردی یافت نشد', 'red')
          return
        }
        this.aiModuleShow = true

        this.aiModuleResponse = res.data.data
      }).catch(err => {
        this.loadingAi = false
        this.loadingAiModule = false
        console.log(err)

      })
    },
    recordeVoiceFunc(index) {
      this.indexTaskSelected = index
      this.voiceRecorderModal = true
    },
    getAi(index) {
      let text = this.forms[index].description
      if (this.forms[index].type_id === '') {
        this.showMsg('لطفا یک گروه درخواست انتخاب کنید!', 'red')
        return
      }
      if (text === '') {
        this.showMsg('ابتدا توضیحات خود را وارد کنید', 'red')
        return;
      }


      this.loadingAi = true
      const fieldMap = [
        {key: "name", label: "نام"},
        {key: "family", label: "نام خانوادگی"},
        {key: "meli_code", label: "کد ملی"},
        {key: "phone", label: "شماره موبایل"},
        {key: "tel", label: "شماره ثابت"},
        {key: "province", label: "استان مبدا تماس"},
        {key: "city", label: "موقعیت مراجع"},
        {key: "level", label: "میزان اهمیت"},
        {key: "status_id", label: "وضعیت"},
        {key: "answer", label: "پاسخ"},
        {key: "description", label: "توضیحات"},
        {key: "note", label: "یادداشت"},
        {key: "fileds", label: "فیلدها"},
        {key: "tags", label: "تگ ها"}
      ];
      let fields = []
      this.acc[index].forms.forEach(form => {
        form?.fields?.forEach(field => {

          let value = this.formDataArr[form.id][field.id]
          if (field.field_type === 'multiple_select') {
            value = value.join(',')
          } else if (field.field_type === 'checkbox') {
            value = this.checkboxesModel.join(',')
          }
          if (value !== '') {

            fields.push({key: field.title, value: value})
          }

        })
      })
      let additional_data = fieldMap
          .filter(field => {
            const val = this.forms[index][field.key];
            return val !== undefined && val !== null && val !== "";
          })
          .map(field => ({
            key: field.label,
            value: this.forms[index][field.key]
          }));
      if (fields.length > 0) {
        additional_data = [...additional_data, ...fields];
      }

      let body = {
        task_type_id: +this.nodeId,
        input_text: text,
        additional_data: additional_data
      }
      axios.post(this.apiBaseUrl + 'api/ai/suggest-by-category', body,
          {headers: this.headers}).then(res => {
        this.aiShow = true
        this.aiResponse = res.data
        this.loadingAi = false
        this.indexTaskSelected = index
      }).catch(err => {
        this.loadingAi = false
        console.log(err)

      })

    },
    handleFileUpload(index, event) {
      this.indexTaskSelected = index;

      const selectedFiles = Array.from(event.target.files);
      if (selectedFiles.length === 0) return;

      this.files[index].push(...selectedFiles);

      const MAX_SIZE = 1024 * 1024; // 1MB

      this.validationFiles = selectedFiles.map(file => {
        // بررسی نوع فایل با فرمت‌های دقیق‌تر
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        const isPdf = file.type === "application/pdf";

        // فقط فرمت‌های خاص برای تصویر
        let isValidImageType = false;
        if (isImage) {
          const allowedImageTypes = [
            "image/jpeg",
            "image/jpg",      // بعضی مرورگرها این را برمی‌گردانند
            "image/png",
            "image/webp"
          ];
          isValidImageType = allowedImageTypes.includes(file.type);
        }

        const isValidType = (isValidImageType) || isVideo || isPdf;

        const isValidSize = file.size <= MAX_SIZE;

        return {
          file: file,
          name: file.name,
          size: (file.size / (1024 * 1024)).toFixed(2) + ' MB',
          type: file.type,
          preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
          isValid: isValidType && isValidSize,
          errors: []
        };
      });

      // پر کردن خطاها
      this.validationFiles.forEach(item => {
        if (!item.isValid) {
          if (!item.isValid) { // قبلاً بررسی نوع
            const isImage = item.file.type.startsWith("image/");

            if (isImage) {
              item.errors.push("فقط فرمت‌های JPG, JPEG, PNG و WEBP برای تصاویر مجاز است");
            } else if (!item.file.type.startsWith("video/") && item.file.type !== "application/pdf") {
              item.errors.push("فرمت فایل مجاز نیست");
            }
          }

          if (item.file.size > MAX_SIZE) {
            item.errors.push("حجم فایل بیشتر از ۱ مگابایت است");
          }
        }
      });

      const allValid = this.validationFiles.every(f => f.isValid);
      if (allValid) {
        this.commitValidFiles();
      } else {
        this.attachInfoModal = true;
      }

      event.target.value = "";
    },
    commitValidFiles() {
      this.validationFiles.forEach(item => {
        if (item.isValid) {
          if (!this.attachment[this.indexTaskSelected]) {
            this.attachment[this.indexTaskSelected] = [];
          }

          this.attachment[this.indexTaskSelected].push({
            name: item.name,
            type: item.type,
            preview: item.preview,
            file: item.file
          });
        }
      });

      this.clearValidation();
      this.showMsg("فایل‌ها با موفقیت اضافه شدند", "green");
    },

    clearValidation() {
      // پاک کردن object URL ها برای جلوگیری از memory leak
      this.validationFiles.forEach(item => {
        if (item.preview) URL.revokeObjectURL(item.preview);
      });
      this.validationFiles = [];
      this.attachInfoModal = false;
    },

    removeValidationFile(index) {
      const item = this.validationFiles[index];
      if (item.preview) URL.revokeObjectURL(item.preview);

      this.validationFiles.splice(index, 1);

      if (this.validationFiles.length === 0) {
        this.clearValidation();
      } else if (this.validationFiles.every(f => f.isValid)) {
        this.commitValidFiles();
      }
    },
    getdepartments() {

      axios.get(this.apiBaseUrl + 'api/departments',
          {headers: this.headers}).then(res => {

        this.deparments = res.data.data

      }).catch(err => {
        console.log(err)

      })
      axios.get(this.apiBaseUrl + 'api/departments/department-users',
          {headers: this.headers}).then(res => {

        this.departmentUsers = res.data.data


      }).catch(err => {
        console.log(err)

      })
    },
    getProvinces() {

      axios.get(this.apiBaseUrl + 'api/tasks/province',
          {headers: this.headers}).then(res => {
        this.provinces = res?.data?.data


      }).catch(err => {
        console.log(err)

      })
    },
    getTaskTypeFields(id) {
      this.nodeId = id
      if (this.nodeId === '') {
        return
      }
      if (id) {
        axios.get(`${this.apiBaseUrl}api/task/types/${id}/form-field`,
            {headers: this.headers}).then(res => {
          this.fields = res?.data?.data?.data?.forms

          this.acc.forEach((item) => {

            if (item.idNode === id) {
              item.forms = this.fields
              item.forms.forEach(form => {

                if (!this.formDataArr[form.id]) {
                  this.formDataArr[form.id] = {};

                }
                form?.fields?.forEach((field) => {
                  if (!this.formDataArr[form.id][field.id]) {
                    let val = field.field_type === 'checkbox' ? field.options[0] : ''
                    if (field.field_type === 'radio') {
                      val = field.options.find(x => x.default === true).value
                    }
                    this.formDataArr[form.id][field.id] = val;
                  }
                });

              })
            }

          })


          store.commit('setdisableInput', false)
          this.loadingPage = false


        }).catch(err => {
          console.log(err)

        })
      }

    },
    getTaskLevels() {

      axios.get(this.apiBaseUrl + 'api/tasks/levels',
          {headers: this.headers}).then(res => {
        this.levels = []
        res?.data?.data.forEach((x, index) => {
          this.levels.push({index: index, name: x})
        })

        let index = this.acc.length - 1
        this.forms[index].level = res?.data?.data[0]


      }).catch(err => {
        console.log(err)

      })
    },
    setTaskType(id = '') {
      this.nodeId = id

      let body = {id: id}
      axios.post(this.apiBaseUrl + 'api/tasks/generate-code', body,
          {headers: this.headers}).then((res) => {
        let index = this.acc.length - 1
        let code = res?.data?.data
        this.forms[index].code = code
        this.forms[index].province = 9
        this.files[index] = []
        this.taskAddedSuccessful[index] = false
        this.showTree = false
        this.getdepartments()
        this.getTasksLocation(index)


      }).catch(err => {
        console.log(err)

      })
    },
    logout() {
      store.commit('setLogout', true);
    },
    removeAcc(index) {

      this.acc.splice(index, 1)

    },

    getTasksLocation(index) {
      this.loading = true
      setTimeout(() => {
        let province_id = this.forms[index].province
        let body = {province_id: province_id}
        axios.post(this.apiBaseUrl + 'api/tasks/locations', body,
            {headers: this.headers}).then(res => {
          this.disableCity[index].val = false

          this.cities[index] = res?.data?.data
          this.forms[index].city = 'تهران'

          this.loading = false
        }).catch(err => {
          console.log(err)

        })
      }, 1000)

    },
    getAccess() {
      if (this.userData) {
        let data = this.userData
        if (data?.data?.features) {

          this.aiAccess = data?.data?.features.some((feature) => feature.name.toLowerCase() === 'artificial_intelligence');
        }
        /* Object.keys(this.accessMenus).forEach((key) => {
           const featureName = key.toLowerCase();
         });*/
      }
    },
    getStatus() {
      this.getAccess()

      axios.get(this.apiBaseUrl + 'api/task/statuses',
          {headers: this.headers}).then(res => {
        this.statuses = res?.data?.data.data
        let index = this.acc.length - 1
        this.forms[index].status_id = this.statuses[0].id

      }).catch(err => {
        console.log(err)

      })
    },
    handleSelection2(node, index) {
      let fined = this.acc[index]
      fined.title = node.title
      fined.titleButton = 'گروه درخواست :' + ' ' + node.title
      fined.idNode = node.id
      this.showTree = false
      this.forms[index].type_id = node.id
      this.getTaskTypeFields(node.id)
      /*if (node.isChecked) {
        this.loadingPage = true
        this.setTaskType(node.id)
      }*/


    },
    getTaskInfo(task) {
      task.taskEditLoading = true
      axios.get(this.apiBaseUrl + 'api/tasks/' + task.id,
          {headers: this.headers}).then((res) => {
        let data = res.data.data
        this.setContactInfo2(data.contact)
        this.tasksAllShow = false
        task.taskEditLoading = false
        let index = this.indexTaskSelected
        let fined = this.acc[index]
        fined.title = data.task.type_title
        fined.titleButton = 'گروه درخواست :' + ' ' + data.task.type_title
        fined.idNode = data.task.type_id
        this.getTaskTypeFields(fined.idNode)
        this.showTree = false

        this.forms[index].type_id = data.task.type_id
        this.forms[index].tags = data.task.tags
        this.forms[index].status_id = data.task.status_id
        this.forms[index].is_closed = data.task.is_closed == 1 ? 'بسته' : 'باز'
        this.forms[index].description = data.task.description
        this.related[index] = true
        this.attachment[index] = data.attachments
        this.notes = data.notes
        this.answers = data.answers
        this.cartable_id = data.task.cartable_id
        this.forms[index].city = data.contact.city
      }).catch(err => {
        task.taskEditLoading = true
        this.showMsg('مشکلی پیش آمده', 'red')
        console.log(err)

      })
    },
    getLastTasks(filter = '') {
      let today = moment().format('YYYY-MM-DD')
      this.loadingSearch = true
      let url = this.apiBaseUrl + 'api/tasks?per_page=10&from_date=' + today
      if (filter !== '') {
        url = this.apiBaseUrl + 'api/tasks?per_page=10&id=' + filter
      }


      axios.get(url, {headers: this.headers})
          .then(res => {
            this.lastTasks = res.data.data
            this.loadingSearch = false

          }).catch(() => {
        this.loadingSearch = false
      })
    },
    toJalali(date) {
      return moment(date, 'YYYY-M-D').format('jYYYY/jM/jD')
    },
    submitRequest(index, trans = false) {
      let error = false
      let rawTags = Array.isArray(this.forms[index].tags) ? this.forms[index].tags : [];
      let tagsArr = rawTags.filter(tag => tag !== "");
      const currentForm = this.forms[index]
      this.confirmChangeContact = false

      if (currentForm.name === '' && currentForm.family === '') {
        this.showMsg('لطفا نام و نام خانوادگی را وارد کنید!', 'red')
        return
      }
      if (currentForm.meli_code?.length !== 10) {
        this.showMsg('لطفا کد ملی را به درستی وارد کنید!', 'red')
        return
      }
      if (currentForm.status_id === '') {
        this.showMsg('لطفا وضعیت را انتخاب کنید!', 'red')
        return
      }
      if (currentForm.description === '') {
        this.showMsg('لطفا توضیحات را وارد کنید!', 'red')
        return
      }
      if (currentForm.city === '' || currentForm.city === null) {
        this.showMsg('لطفا شهر و استان را انتخاب کنید!', 'red')
        return
      }
      if (currentForm.type_id === '' || currentForm.type_id === undefined) {
        this.showMsg('لطفا یک گروه درخواست انتخاب کنید', 'red')
        return
      }

      let fields = []
      if (this.acc[index].forms) {
        this.acc[index].forms.forEach(form => {
          form?.fields?.forEach(field => {
            if (field.required === 1 && !this.formDataArr[form.id][field.id]) {
              error = true
              return
            }
            let value = this.formDataArr[form.id][field.id]
            if (field.field_type === 'multiple_select') {
              value = value.join(',')
            } else if (field.field_type === 'checkbox') {
              value = this.checkboxesModel.join(',')
            }
            fields.push({form_id: form.id, field_id: field.id, value: value})
          })
        })
      }
      if (error) {
        this.showMsg('لطفا تمام موارد ضروری را وارد کنید!', 'red')
        return;
      }
      const formChanged =
          currentForm.name !== this.contactSelected.name ||
          currentForm.family !== this.contactSelected.family ||
          currentForm.meli_code !== this.contactSelected.meli_code ||
          currentForm.province !== this.contactSelected.province_id ||
          currentForm.phone !== this.contactSelected.phones?.mobile ||
          currentForm.tel !== this.contactSelected.phones?.home

      if (formChanged && this.contactSelected !== '' && this.editContact === 0) {
        this.confirmChangeContact = true
        return;
      }


      this.loading = true

      this.errors = []
      let formData = new FormData();
      if (this.editContact === 1 || this.contactSelected !== '') {
        formData.append('contact_id', this.contactSelected.id);
      }

      formData.append('code', currentForm.code);
      formData.append('type_id', currentForm.type_id);
      formData.append('name', currentForm.name);
      formData.append('family', currentForm.family);
      formData.append('meli_code', currentForm.meli_code);
      if (currentForm.tel) {

        formData.append('home', currentForm.tel);
      }
      formData.append('mobile', currentForm.phone);
      formData.append('province', currentForm.province);
      formData.append('city', currentForm.city);
      formData.append('cartable_id', this.cartable_id);
      /* formData.append('cartable_draft_id', this.cartable_id);*/
      formData.append('description', currentForm.description);
      formData.append('level', currentForm.level);
      formData.append('status_id', currentForm.status_id);
      formData.append('note', currentForm.note);
      formData.append('answer', currentForm.answer);

      if (currentForm.answer_attachments) {
        formData.append('answer_attachments[]', currentForm.answer_attachments);
      }
      if (this.dataProp) {
        formData.append('cartable_draft_id', this.dataProp.portalId);
        if (this.dataProp.cartable_id === 2) {
          formData.append('voice_mail_id', this.dataProp.portalInfo.id);
        }

      }

      formData.append('fields', JSON.stringify(fields));
      formData.append('is_closed', currentForm.is_closed === 'باز' ? 0 : 1);
      tagsArr.forEach(tag => {
        formData.append('tag_ids[]', tag);
      });
      if (this.files[index] !== undefined && this.files[index].length > 0) {
        this.files[index].forEach((file) => {
          formData.append("attachments[]", file);
        });
      }
      if (trans) {
        formData.append('department_id', this.departmentsModel[index].id);
        if (this.userInfo.department_id === this.departmentsModel[index].id) {

          formData.append('assignee_user_id', this.departmentsModel[index].user);
        }
      }
      if (this.isComponent && !this.isVoiceMail) {
        formData.append('portal_id', this.dataProp?.portalId);
      }
      let url = this.apiBaseUrl + 'api/tasks'
      if (this.related[index]) {
        url = this.apiBaseUrl + 'api/tasks/' + this.eventData.task_id
        formData.append('call_id', this.eventData.id);

      }


      axios.post(url, formData,
          {headers: this.headers}).then(() => {
        this.loading = false
        this.transmissionModal = false
        this.showMsg('با موفقیت ثبت شد', 'green')
        this.taskAddedSuccessful[index] = true
        let param = this.$route.params.id
        if (this.isComponent) {
          param = this.cartable_id
        }
        this.$router.push({name: 'TasksComponent', params: {id: param}})
        this.taskAddedSuccessful[index] = false
        this.$emit('close-modal');


      }).catch(err => {
        this.loading = false

        this.errors = err?.response?.data?.errors
        if (err?.response?.status === 429) {
          console.log(err)
          const Error = err.response.data.message
          this.showMsg(Error, 'red')
        }

      })


    },
    checkMobile(mobile) {
      const phoneRegex = /^(\+98|0)?9\d{9}$/;
      return phoneRegex.test(mobile)
    },
    setContactInfo(id, i) {
      let data = this.contacts[i].find(x => x.id === id)
      this.forms[i].name = data.name
      this.forms[i].family = data.family
      this.forms[i].meli_code = data.meli_code
      this.forms[i].province = data.province_id
      let phones = data.phones

      this.forms[i].tel = phones.home
      this.getTasksLocation(i)

      this.contactShow = false
    },
    setContactInfo2(contact) {
      let i = this.indexTaskSelected
      this.forms[i].name = contact.name
      this.forms[i].family = contact.family
      this.forms[i].meli_code = contact.meli_code
      this.forms[i].province = contact.province_id
      this.forms[i].phone = contact.phones?.mobile
      this.forms[i].tel = contact.phones?.home
      this.contactSelected = contact

      this.getTasksLocation(i)

      this.contactAllShow = false
    },
    findContact(phone, index, first = false) {
      if (!this.checkMobile(phone)) {
        this.showMsg('لطفا شماره موبایل را به درستی وارد کنید!', 'red')
        return

      }

      this.loadingContact = true
      let body = {phone: phone}
      axios.post(this.apiBaseUrl + 'api/contacts/find', body,
          {headers: this.headers}).then(res => {
        this.contacts[index] = res.data.data
        this.loadingContact = false
        if (this.contacts[index].length > 0) {

          this.disableContact[index].val = false

          if (first) {
            let dataUser = res.data.data[0]
            this.indexTaskSelected = 0
            this.setContactInfo2(dataUser)


          }
        }

      }).catch(err => {
        console.log(err)
      })
    },
    getTree() {

      axios.get(this.apiBaseUrl + 'api/task/types/type-tree',
          {headers: this.headers}).then(res => {
        this.treeData = res.data.data
        const addChecked = nodes => {
          nodes.forEach(node => {
            node.isChecked = false;
            if (node.children && node.children.length) addChecked(node.children);
          });
        };
        addChecked(this.treeData);

      }).catch(err => {
        console.log(err)
      })
    },
    getTags() {
      axios.get(this.apiBaseUrl + 'api/tags',
          {headers: this.headers}).then(res => {
        this.tags = res?.data?.data?.data;
        const index = this.acc.length - 1
        this.forms[index].tags = this.tags[0]
      }).catch(err => {
        console.log(err)
        /*   if (err?.response?.status === 401) {
             this.logout()
           }*/
      })
    },
    checkParameter() {
      let param = this.$route.params.id

      this.cartable_id = param
      if (param === undefined && this.isComponent) {
        this.cartable_id = this.dataProp.cartable_id
      }

      if (!param || isNaN(param)) {
        if (!this.isComponent) {

          this.$router.push({name: 'TasksComponent', params: {id: '0'}});
        }
      }

    },
    onlyNumber(index) {
      this.forms[index].meli_code = this.forms[index]?.meli_code?.replace(/[^0-9]/g, '');
      this.forms[index].tel = this.forms[index]?.tel?.replace(/[^0-9]/g, '');
      this.forms[index].phone = this.forms[index]?.phone?.replace(/[^0-9]/g, '');
    },
    getDataComponent() {

      this.acc = [{
        id: this.dataProp.type_id,
        active: true,
        title: this.dataProp.type_title,
        titleButton: this.dataProp.type_title ?? 'افزودن گروه درخواست'
      }]
      this.acc.forEach((item) => {
        let fields = this.dataProp?.portalInfo?.forms
        item.forms = fields

        fields?.forEach(form => {

          if (!this.formDataArr[form.id]) {
            this.formDataArr[form.id] = {};

          }
          form?.fields?.forEach((field) => {
            if (!this.formDataArr[form.id][field.id]) {

              this.formDataArr[form.id][field.id] = field.value;
            }
          });
        })


      })
      this.getTaskTypeFields(this.dataProp.type_id)
      this.getdepartments()
      this.taskAddedSuccessful[0] = false

      this.forms[0].code = this.dataProp?.portalInfo?.portal?.code
      let contact = this.dataProp?.portalInfo?.contact
      this.forms[0].name = contact?.name ?? contact?.first_name ?? ''
      this.forms[0].family = contact?.family ?? contact?.last_name ?? ''
      this.forms[0].meli_code = contact?.meli_code
      this.forms[0].province = contact?.province_id
      let phones = [];

      if (Array.isArray(contact?.phones)) {
        phones = contact.phones;
      } else {
        try {
          const parsed = JSON.parse(contact?.phones);
          if (Array.isArray(parsed)) {
            phones = parsed;
          }
        } catch (e) {
          phones = [];
        }
      }

      const telItem = phones.find(x => x.name === 'tel');
      const phoneItem = phones.find(x => x.name === 'phone');
      const phone2 = contact?.phone_number || '';

      this.forms[0].tel = telItem?.number || '';
      this.forms[0].phone = phoneItem?.number ?? phone2 ?? '';
      this.forms[0].description = this.dataProp?.portalInfo?.portal?.description
      this.forms[0].level = this.dataProp?.portalInfo?.portal?.level
      this.forms[0].city = this.dataProp?.portalInfo?.portal?.city
      this.forms[0].type_id = this.dataProp?.type_id
      this.attachment[0] = this.dataProp.attachments


    },
    getCookie() {
      return localStorage.getItem('token');
    },
    showMsg(msg, color) {
      this.snackbar = true
      this.textSnack = msg
      this.colorSnack = color
    },
    debouncedSearch(title, name) {
      const value = this.filterVals[name];
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        const existingTag = this.tagsFilter.find(tag => tag.title === title);

        let displayValue = value;
        let displayValueTitle = value;


        if (!existingTag) {
          this.tagsFilter.push({
            title,
            value: displayValue,
            valueTitle: displayValueTitle,
            name
          });
        } else {
          existingTag.value = displayValue;
          existingTag.valueTitle = displayValueTitle;
        }
      }, 100);
    },
    resetForm() {
      this.acc = []
      this.taskAddedSuccessful.forEach(x => x.val = false)
    },
  },
  mounted() {
    this.resetForm()
    this.addNewAcc()
    this.checkParameter()
    this.getTree()
    this.getTags()
    this.getProvinces()
    this.getTaskLevels()
    this.getStatus()
    this.getContacts()
    if (this.isComponent) {
      this.getDataComponent()
    }
    if (this.isComponent2) {
      this.findContact(this.eventData.callerid, 0, true)
      this.getLastTasks()
    }
    document.addEventListener("click", this.handleClickOutside);


  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
}
</script>

<style scoped lang="scss">
.add-btn-attach {
  background: #1f9d62;
  border-radius: 99px;
  color: #fff;
  position: relative;

  a {
    color: #fff;
  }

  input {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    top: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}

.excel-upload-modal {
  border-radius: 20px !important;
}

.excel-icon {
  width: 90px;
  height: 90px;
  margin: auto;
  border-radius: 50%;
  background: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.excel-icon i {
  font-size: 42px;
  color: #2e7d32;
}

.upload-rules {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.rule-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f7f8fa;
  text-align: right;
}

.rule-item i {
  color: #2e7d32;
  font-size: 18px;
  min-width: 20px;
}

.rule-item span {
  font-size: 14px;
  color: #444;
}

.comments {
  overflow: auto;
  scrollbar-width: thin;
  max-height: calc(100vh - 200px);
  direction: ltr;

  .box-c {
    direction: rtl;
    width: 100%;
    background: #F3F4F6;
    padding: 12px;
    border-radius: 16px 16px 0 16px;
    margin: 10px 0;

    h5 {
      font-size: 14px;
      color: #3D444F;
      padding: 10px 0;
    }

    p {
      color: #6C798B;
      line-height: 21px;
      font-size: 14px;
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: left;

      span {
        display: flex;
        color: #6C798B;
        font-size: 12px;
        padding: 0 10px;

        i {
          font-size: 14px;
          margin-left: 5px;
        }
      }
    }

  }
}

.dialog-ai .box-modal {
  max-height: calc(100vh - 80px);
  overflow: auto;
  scrollbar-width: thin
}

.add-contact {
  background: #ff931e;
  padding: 4px 14px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  transition: all ease .4s;

  &:hover {
    opacity: .7;
  }
}

.contact-all-list {
  max-height: calc(100vh - 40px);
  overflow: auto;
}

.table-section {
  border-radius: 24px;
  border: 1px solid #EDEEF1;
  overflow: auto;
  width: 100%;


  table {

    thead {
      th, td {
        padding: 15px;
        color: #363B44;
        border-bottom: none;
        font-weight: 100;

        i {
          color: #D7DBE0;
        }
      }
    }

    tbody {
      th, td {
        color: #6C798B;
        font-weight: 100;
        padding: 15px;
        vertical-align: middle;
      }

      tr:last-child {
        td, th {
          border-bottom: none;
        }
      }
    }
  }

}

.add-new-button {
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #D7DBE0;
  border-radius: 24px;
  margin-top: 10px;
  cursor: pointer;
  transition: all ease .4s;

  i {
    margin-left: 8px;
  }

  &:hover {
    opacity: .7;
  }
}

.btn-download {
  box-shadow: none;
}

.input-date {
  max-height: 48px;
}

.list-text-data {
  span {
    padding: 10px;
    display: block;
    width: 100%;
    font-size: 14px;
  }
}

.btn-ai-response {
  border: 1px solid #D8F4FF;
  display: flex;
  align-items: center;
  color: #0A75D8;
  font-size: 10px;
  height: 30px;
}

.alert {
  span {
    display: block;
    width: 100%;
    padding: 2px 0;
    font-size: 13px;
  }
}

.tags {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .tag {
    background: #D7DBE0;
    border-radius: 99px;
    padding: 5px 10px;
    font-size: 12px;
    margin-left: 10px;
    display: flex;
    align-items: center;

    i {
      margin-right: 10px;
    }
  }

}

.box-modal {
  position: relative;
  width: 100%;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  border-radius: 32px;
  padding: 32px;

  .top {
    display: flex;
    align-items: center;
    width: 100%;

    i {
      margin-right: auto;
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .forms {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .input {
      width: 50%;
      padding: 10px;

      label {
        width: 100%;
        text-align: right;
        padding: 5px 10px;
        margin-bottom: 8px;
      }
    }
  }
}

::placeholder {
  color: #8A96A6;
  opacity: 1; /* Firefox */
}

::-ms-input-placeholder { /* Edge 12 -18 */
  color: #8A96A6;
}


.main-popup {
  padding: 32px;

  .pop-up {
    padding: 32px;
    border-radius: 32px;
    width: 100%;
    background: #fff;
    box-shadow: 0 0 5px #ccc;

    .head {
      display: flex;
      align-items: center;

      i {
        color: #222;
      }

      .btns-top {
        margin-right: auto;

        button {
          display: flex;
          align-items: center;
          color: #E22C1F;
          margin-left: 15px;
          font-size: 14px;
          cursor: default;

          i {
            border: none !important;

            margin-left: 5px;
          }

        }
      }

      h4 {
        margin-left: auto;
        font-size: 20px;
        color: #363B44
      }
    }

    .form {
      display: flex;
      flex-wrap: wrap;
      direction: rtl;

      p {
        font-size: 14px;
        padding: 0 10px;

      }

      .title {
        .btn-users {
          border: 1px solid #D8F4FF;
          display: flex;
          align-items: center;
          color: #0A75D8;
          font-size: 10px;

        }
      }

      h5 {
        width: 100%;
        font-size: 16px;
        color: #363B44;
        padding: 10px;
      }

      .input {
        width: 33.333%;
        padding: 10px;

        > label {
          width: 100%;
          font-size: 14px;
          color: #3D444F;
          padding: 10px;
        }

        > input, > textarea {
          width: 100%;
          padding: 10px;
          border-radius: 99px;
          border: 1px solid #D7DBE0;
          height: 48px;

          &:disabled {
            background: rgba(238, 238, 238, 0.62);
          }
        }

        &.field-box {
          label em {
            color: red;
          }

          .check-div, .radio-div {
            width: 100%;
            margin-bottom: 5px;
            display: flex;
            flex-wrap: wrap;

            label {
              width: 100%;
              font-size: 14px;
              color: #3D444F;
              padding: 10px;
            }

            > div {
              display: flex;
              align-items: center;
              padding: 5px;

              label {
                margin-bottom: 0;
                padding: 0 4px;
              }
            }
          }

        }
      }

      @media (max-width: 576px) {
        .title {
          flex-wrap: wrap;

          h5 {
            width: 100% !important;
          }

          .btn-users {
            width: 45%;
          }
        }


      }

    }


    .accordion-div {
      direction: rtl;
      padding: 10px;
      @media (max-width: 576px) {
        padding: 0;

      }

      .accordion {
        border: 1px solid #D7DBE0;
        border-radius: 24px;

        margin: 10px 0;

        .head {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 15px 25px 0;

          span {
            font-size: 16px;
            font-weight: bold;
          }

          i {
            margin-right: auto;
            width: 18px;
            height: 18px;
            border: 2px solid #474F5D;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          button {
            i {
              color: #E22C1F;
            }
          }
        }

        .form-par {
          display: none;
          padding: 0 15px 15px 15px;
          flex-wrap: wrap;

          form {
            width: 100%;
          }

          &.active {
            display: flex;
          }

          @media (max-width: 576px) {


          }


        }

      }

    }

    .attachments {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 20px;

      h6 {
        font-size: 16px;
        color: #363B44;
      }

      .right-box {
        width: 100%;

        .attach {
          display: flex;
          align-items: center;
          background: #F3F4F6;
          border-radius: 16px;
          padding: 10px;
          margin: 10px 0;

          span {
            margin: 0 5px;
            color: #363B44;
            font-size: 14px;
            max-width: 100%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          button {
            margin-right: auto;
            color: #E22C1F;
          }

        }

        .btn-upload {
          width: 100%;
          border: 1px solid #0A75D8;
          color: #0A75D8;
          padding: 10px;
          text-align: center;
          border-radius: 99px;
          transition: all ease .4s;
          position: relative;

          input {
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            left: 0;
            z-index: 1;
            cursor: pointer;

          }

          &:hover {
            opacity: .7;
          }
        }
      }

      .left-box {
        width: 33.333%;
        padding-right: 15px;

        textarea {
          width: 100%;
          height: 190px;
          border: 1px solid #D7DBE0;
          border-radius: 16px;
          padding: 15px;
          transition: all ease .4s;

          &:focus {
            outline: none;
          }
        }

        h6 {
          line-height: 2;
        }
      }

    }
  }


}

.btns-bottom {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;

  .btn-save {
    width: calc(50% - 10px);
  }

  .btn-transmission {
    background: transparent;
    color: #C75407;
    border: 1px solid #C75407;
    width: calc(50% - 10px);
    border-radius: 99px !important;
    padding: 15px !important;
    font-size: 14px !important;
    display: flex !important;
    height: auto !important;
    box-shadow: none;

    i {
      margin-left: 10px;
    }
  }
}

.btn-cancel {
  border-radius: 99px !important;
}

.btn-save {
  background: #F07006 !important;
  transition: all ease .4s;

  &:hover {
    opacity: .7;
  }
}

.btns-add {
  position: relative;

  .tree-box {
    height: max-content;
    max-height: 300px;
    scrollbar-width: thin;
    width: 300px;
    background: #fff;
    border-radius: 24px;
    top: 60px;
    right: 10px;
    box-shadow: 0 0 5px #ccc;
    overflow: auto;
    padding: 15px;
    z-index: 1;
    position: absolute;
  }

  button {
    direction: rtl;
    background: #24272D;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    color: #fff;
    border-radius: 99px;
    font-size: 14px;
    transition: all ease .4s;
    bottom: 10px;
    right: 10px;
    z-index: 2;

    &:hover {
      background: #000000;
    }

    i {
      margin-left: 10px;
    }
  }
}

@media (max-width: 767px) {

  .main-popup {
    padding: 10px;

    .pop-up {
      padding: 15px;

      .form {
        .input {
          padding: 0;
          width: 100%;
        }
      }

      .attachments {
        .right-box, .left-box {
          width: 100% !important;
          padding: 10px 0;

          .label {
            flex-wrap: wrap;

            h6 {
              width: 100%;
            }

            button {
              padding: 2px;
              width: 47% !important;
            }

          }
        }
      }
    }
  }

}
</style>
